import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import { BUSINESS_NAME, PHONE_DISPLAY } from "@/data/site";

export default function Privacy() {
  return (
    <>
      <Seo
        title="Privacy Policy | Authentically Yours Property Services"
        description="How Authentically Yours Property Services LLC collects and uses the information you share when requesting an estimate."
        path="/privacy"
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Privacy Policy", path: "/privacy" },
        ]}
      />
      <PageHero
        eyebrow="Legal"
        title="Privacy Policy"
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Privacy Policy", path: "/privacy" },
        ]}
      />
      <div className="container-x py-16 sm:py-24 max-w-3xl space-y-6 text-ink/75 leading-relaxed">
        <p>
          {BUSINESS_NAME} ("we," "us") respects your privacy. This policy explains
          what information we collect through this website and how we use it.
        </p>
        <h2 className="text-2xl text-ink pt-4">Information We Collect</h2>
        <p>
          When you submit an estimate request or contact us, we collect the details
          you provide — such as your name, phone number, email, property information,
          service details and any photos you choose to upload. We only ask for what
          helps us understand and respond to your request.
        </p>
        <h2 className="text-2xl text-ink pt-4">How We Use It</h2>
        <p>
          We use your information solely to respond to your inquiry, provide
          estimates, schedule and perform services, and communicate with you about
          your request. We do not sell your personal information.
        </p>
        <h2 className="text-2xl text-ink pt-4">Contact Preferences</h2>
        <p>
          By submitting the estimate form you consent to be contacted about your
          request by your preferred method. You may ask us to stop contacting you at
          any time.
        </p>
        <h2 className="text-2xl text-ink pt-4">Questions</h2>
        <p>
          Questions about this policy? Call or text us at {PHONE_DISPLAY}. This policy
          may be updated from time to time; the current version will always appear on
          this page.
        </p>
      </div>
    </>
  );
}
